import { useState } from "react";
import { HiShoppingCart } from "react-icons/hi";
import { TbCurrencyTaka, TbPackageOff } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { FaCartPlus, FaTag, FaTruck } from "react-icons/fa";
import StockOut from "./stockOut";
import ShimmerCardGrid from "./shimmer/ShimmerCardGrid";
import useCart from "./useCart";

const CardDesign = ({ likeData, loading, error }) => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { addToCart } = useCart();

  if (loading)
    return (
      <ShimmerCardGrid />
    );

  return (
    <div className="container mx-auto px-4 sm:px-6 md:px-10">
      <div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-4 gap-4">
          {likeData?.length ? (
            likeData
              .filter((item) => item.hideStatus === "available")
              .map((item, index) => {
                const isOutOfStock = item.status === "unavailable";
                // ✅ Split title and flashPrice per product
                const firstVariant = item.variants?.[0] || {};
                const firstImage = firstVariant.images?.[0] || "";

                const selectedTitle = firstVariant.title || "-";
                const selectedPrice = firstVariant.flashPrice || 0;
                const selectedDiscount = firstVariant.discount || 0;
                const originalPrice = selectedDiscount || 0;
                const flashPrice = selectedPrice || 0;

                const discountPercent =
                  originalPrice > 0
                    ? Math.ceil(
                        ((originalPrice - flashPrice) / originalPrice) * 100,
                      )
                    : 0;
                return (
                  <div
                    key={index}
                    className={`relative flex flex-col flex-shrink-0 lg:w-[340px] md:w-[240px] max-md:basis-[47%] bg-white rounded-[10px] overflow-hidden transition-transform duration-200 
                                        ${isOutOfStock ? "opacity-40" : ""}
                                    `}
                  >
                    {isOutOfStock && <StockOut />}

                    <a href={`/details/${item.catalogue}/${item.item_id}`}>
                      <div className="relative group aspect-product-desktop w-full overflow-hidden">
                        <img
                          src={`https://backend.nuhababy.com/${firstImage}`}
                          alt={selectedTitle}
                          className="transition-transform duration-1000 ease-in-out transform w-full group-hover:scale-105  cursor-pointer rounded-t-[10px]"
                        />
                        {discountPercent > 0 && (
                          <span className="absolute left-2 top-2 inline-flex items-center gap-1 rounded-full bg-rose-600 px-2 py-1 text-[10px] font-semibold text-white">
                          <FaTag className="text-[9px]" />
                          {discountPercent}% OFF
                        </span>
                        )}
                        {firstVariant.freeVariantDelivery === 1 && (
                        <span className="absolute bottom-2 right-2 inline-flex items-center gap-1 rounded-full bg-emerald-600/95 px-2 py-1 text-[10px] font-medium text-white">
                          <FaTruck className="text-[10px]" />
                          Free Delivery
                        </span>
                      )}
                      </div>
                    </a>

                    <div className="md:px-3 p-2 flex flex-col flex-grow">
                      <div className="text-black hover:text-[#222836] hover:opacity-60 font-medium tracking-wide mb-1 text-sm whitespace-nowrap overflow-hidden truncate">
                        {item?.mainTitle}
                      </div>
                      <div className="text-black hover:text-[#222836] hover:opacity-60 tracking-wide mb-1 text-xs whitespace-nowrap overflow-hidden truncate">
                        {selectedTitle}
                      </div>
                      <div className="flex pb-2">
                        <div className="relative inline-flex items-center text-gray-400 text-sm mr-2">
                          <span className="flex items-center">
                            <p>{selectedDiscount}</p>
                            <TbCurrencyTaka className="font-semibold" />
                          </span>
                          <div className="absolute left-0 right-0 top-1/2 h-[1px] bg-gray-400"></div>
                        </div>
                        <div className="flex text-[#265fc9] items-center text-sm">
                          <p className="font-bold">{selectedPrice}</p>
                          <TbCurrencyTaka className="font-semibold" />
                        </div>
                      </div>

                      {!isOutOfStock && (
                        <div className="flex gap-2 my-1 mt-auto">
                          <button
                            lang="bn"
                            onClick={(e) => {
                              addToCart(item);
                              navigate("/orderDetails");
                            }}
                            className="md:text-base text-sm flex-1 text-white bg-backgroundColor border border-darkBgColor rounded-md md:px-4 px-2 py-1 md:font-bold font-semibold flex justify-center items-center"
                          >
                            অর্ডার করুন
                          </button>
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              addToCart(item);
                              setDrawerOpen(true);
                            }}
                            className="md:px-3 px-2 rounded-md border text-darkBgColor py-1"
                          >
                            <span className="group-hover:hidden md:text-base text-sm">
                              <FaCartPlus />
                            </span>
                            <HiShoppingCart className="hidden group-hover:block w-5 h-5" />
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
          ) : (
            <div className="flex flex-1 flex-col justify-center items-center text-center text-[#265fc9] py-10">
              <TbPackageOff className="mx-auto w-40 h-40 mb-5 text-backgroundColor animate-pulse" />
              <h3 className="text-base sm:text-lg font-semibold mb-2 mt-5">
                কোনো পণ্য পাওয়া যায়নি
              </h3>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardDesign;
